import {NgModule} from '@angular/core';

import {SecondaryTopicModalComponent} from './index';
import {IonicModule} from 'ionic-angular';
import {TreeListModule} from '../../../tree/tree-list/tree-list.component.module';

/**
 * Module for the SecondaryTopicModalModule
 * @class
 */
@NgModule({
  declarations: [SecondaryTopicModalComponent],
  entryComponents: [SecondaryTopicModalComponent],
  exports: [SecondaryTopicModalComponent],
  imports: [
    IonicModule,
    TreeListModule,
  ],
  providers: [],
})
export class SecondaryTopicModalModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/metadata-menu/topic/secondary-topic-modal/secondary-topic-modal.component.module.ts